<template>
  <div class="search position-relative">
    <div class="tabs background-lb rounded-top" 
      :class="{'bg-disabled' : searchType ==='dropdown' }"
      >
      <div class="btn-group">
        <b-button 
          variant="link"
          class="rounded-top px-2 bg-transparent"
          :class="{'background-lb' : searchType==='dropdown','bg-disabled text-muted' : searchType ==='free' }"
          @click="setSearchType('dropdown')"
          >
          <p class="mb-0">{{hebrew ? 'מילה מרשימת מילים מנוקדות' : 'Word from list'}}</p>
        </b-button>        
        <b-button 
          variant="link"
          class="rounded-top px-2 bg-transparent"
          :class="{  'text-muted' : searchType ==='dropdown' }"
          @click="setSearchType('free')"
          varient="link"
        >
          <p class="mb-0">{{hebrew ? 'חיפוש חופשי' : 'Free search'}}</p>
        </b-button>
      </div>
    </div>
    <div class="background-lb form-wrap p-3 rounded-bottom">
      <b-form-group v-if="searchType==='free'" class="mb-0 bg-white input-wrap"> 
        <b-form-input      
          v-model="searchWord"
          id="search-input"
          ref="searchInput"
          class="d-inline f-narkis w-75 border-0 py-0"          
          @keydown="onKeyDown()"        
          @keyup.enter="runSearch()"
        >
        </b-form-input>
        <b-button 
          variant="link"
          @click="runSearch"
          :disabled="searchWord === ''"
          class="border-none shadow-none d-inline bg-white p-2 w-25 text-left"
          >
            <i class="fas fa-search"></i>
        </b-button> 
      </b-form-group>
      <b-form-group v-else class="mb-0 bg-white">
      <b-form-input 
        v-model="searchWord"
        id="search-input-dd"
        ref="searchInputdd"
        class="d-inline f-narkis w-75 border-0 pt-0"
        @input="runTypeAhead()"
        @keydown="onKeyDownDropdown()"
        @keydown.down="onArrow('down')"
        @keydown.up="onArrow('up')"
        @keydown.esc="onEscape()"        
        @keyup.enter="runSearchFromDropDown()"
        >
      </b-form-input>
      <b-button 
          variant="link"
          :disabled="(taLoading !== 'Complete' &&  showTypeaheads) || searchWord === ''"        
          @click="runSearchFromDropDown"
          class="border-none shadow-none d-inline bg-white p-2 w-25 text-left"
          >
          <i class="fas fa-search"></i>
        </b-button>
      </b-form-group>
      <div class="py-1 mb-n3" v-if="showNikkudMsg && !showTypeaheads && searchWord !== ''">לא ניתן להזין מילה ללא ניקוד</div>
      <div class="py-1 mb-n3" v-if="showNotInList">מילה לא נמצאה ברשימה</div>
    </div>   
    <ul 
      id="search-typeaheads" 
      v-show="typeAheads && typeAheads.length > 0 && showTypeaheads" 
      class="autocomplete-results position-absolute rounded bg-white px-0" tabindex="-1">
      <li v-for="(word, i) in typeAheads" 
        :key="i" 
        @click="setInput( word)"
        :class="{ 'is-active': i === activeIndex }"
        class="autocomplete-result px-2 pb-1 f-narkis"
      >
        {{ word }}
      </li>
    </ul>       
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'
import {englishKeyEventToHebrew} from '@/js/englishToHebrew'
import {NIKUD} from '@/js/nukkudVariables'
import _ from 'lodash'
export default {
  name: 'SearchForm',
  props: {
  },
  data() {
    return {
      searchWord: '',//'יּוּשַׁב',
      tempWord: '',
      showTypeaheads: false,
      activeIndex: 0,
      searchType: 'dropdown',
      showNikkudMsg: false,
      showNotInList: false
    }
  },
  mounted () {
    this.setSearchType (this.searchType)
    this.checkSearchParam()
  },
  methods: {
    setSearchType (searchType) {
      this.searchType = searchType      
      document.activeElement.blur()
      this.$nextTick(function () {        		
        if(searchType === 'free') {
          this.$refs.searchInput.focus()
          this.showTypeaheads = false
          this.showNotInList = false
          if (this.searchWord === '')
            this.searchWord = this.tempWord
        }  else {
          this.$refs.searchInputdd.focus()
          this.tempWord = this.searchWord
          this.searchWord = ''
        }  
      })
    },
    searchTermNikud: function() {
      if (this.searchWord === '' || !this.searchWord) return false
      return this.searchWord.includes(NIKUD.HATAF_SEGOL) ||  this.searchWord.includes(NIKUD.HATAF_PATAH) ||
      this.searchWord.includes(NIKUD.HATAF_QAMATZ) ||  this.searchWord.includes(NIKUD.HIRIQ) ||
      this.searchWord.includes(NIKUD.TSERE) ||  this.searchWord.includes(NIKUD.SEGOL) ||
      this.searchWord.includes(NIKUD.PATAH) ||  this.searchWord.includes(NIKUD.QAMATZ) ||
      this.searchWord.includes(NIKUD.HOLAM) ||  this.searchWord.includes(NIKUD.QUBUTZ) ||
      this.searchWord.includes(NIKUD.SHEVA) ||  this.searchWord.includes(NIKUD.QAMATZ_QATAN)
    },    
    checkSearchParam () {
      const urlParams = new URLSearchParams(window.location.search)
      const searchParam = urlParams.get('search')
      if (searchParam !== null) {
        this.searchWord = searchParam
        if(this.searchTermNikud()) {
          this.runSearch()          
        } else {
          this.runTypeAhead()
        }
      }
    },
    handleTypeAhead: _.debounce(function() {
      this.$store.dispatch(Actions.RUN_TYPE_AHEAD)        
    }, 50),    
    handleSearch: _.debounce(function() {
      this.$store.dispatch(Actions.RUN_SEARCH)        
    }, 50),    
    setInput (word) {
      this.$store.commit('SET_TEXT_FOR_API_CALL',  word)
      this.searchWord = word
      this.showTypeaheads = false
      this.handleSearch()
    },
		onArrow (dir) {
			if (dir == 'down') {
        if (this.activeIndex < this.typeAheads.length - 1)
          this.activeIndex++
        else
          this.activeIndex = 0  
			} else {
        if (this.activeIndex > 0)
          this.activeIndex--
        else
          this.activeIndex = this.typeAheads.length - 1
			}
		},
		onEscape () {
			this.showTypeaheads = false
    },
    onKeyDown () {
      this.showNikkudMsg = false
      englishKeyEventToHebrew(event, 'search-input')
    },     
    onKeyDownDropdown () {
      englishKeyEventToHebrew(event, 'search-input-dd')
    }, 
    runTypeAhead () {    
      if (this.searchWord !== '' || !this.searchWord) {
        this.showNikkudMsg = false
        this.showNotInList = false
        this.$store.commit('SET_TEXT_FOR_API_CALL',  this.searchWord)
        this.showTypeaheads = true
        this.handleTypeAhead()
      }
    },
    runSearchFromDropDown () {
      if (this.searchWord !== '' || !this.searchWord) {
        if (this.activeIndex !== -1 && this.showTypeaheads) {
          this.searchWord = this.typeAheads[this.activeIndex]
        }
        this.showTypeaheads = false
        if (this.searchWord) {
          this.runSearch()
        }  else {
          this.showNotInList = true
          this.searchWord = document.getElementById('search-input-dd').value
          this.$store.commit('SET_TEXT_FOR_API_CALL', this.searchWord)
          this.$store.commit('RESET_RESULTS')
        }  
      }
    },    
    runSearch () {    
      if (this.searchTermNikud() && (this.searchWord !== '' || !this.searchWord)) {
        this.$store.commit('SET_TEXT_FOR_API_CALL',  this.searchWord)
        this.showNikkudMsg = false
        this.handleSearch()
      } else {
        this.showNikkudMsg = true
        this.$store.commit('RESET_RESULTS')
      }
    }
  },
  computed: {
    typeAheads () {
      return this.showBible && this.showTalmud ? _.union(this.bibleTypeAheads, this.talmudTypeAheads) : this.showTalmud ? this.talmudTypeAheads : this.showBible ? this.bibleTypeAheads : []
    },
    taLoading: function () {
      return this.$store.state.taApiState
    },
    apiSearchText: function () {
      return this.$store.state.textForApiCall
    },
    bibleTypeAheads () {
      return this.$store.state.typeAheadApiResponseBible
    },
    talmudTypeAheads () {
      return this.$store.state.typeAheadApiResponseTalmud
    },
    hebrew () {
      return this.$settings.hebrew
    },
    showBible () {
      return this.$store.state.showBible
    },
    showTalmud () {
      return this.$store.state.showTalmud
    }
  },
  watch: {
    apiSearchText (val) {
      if (val === '') {
        this.searchWord = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .tabs {
    margin-top: 35px;
  }
  .rounded-top {
    border-radius: 4px 4px 0 0!important;
  }
  .rounded-bottom {
    border-radius: 0 0 4px 4px!important;
  }  
  .background-lb {
    background-color: #d6ecff!important;
  }
  .input-wrap {
    border-radius: 4px;
  }
  .bg-disabled {
   background:#eef3f7!important;
  }
  .form-control {
    font-size: 25px;
    height: auto;
    line-height: 34px;
  }
  .autocomplete-results {
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.3);
    z-index: 9;
    border: 1px solid #eeeeee;
    height: 330px;
    overflow: auto;
    text-align: right;
    right: 15px;
    margin-top: -15px;
    width: calc(100% - 30px);
  }
  .autocomplete-result {
    cursor: pointer;
  }
  .autocomplete-result.is-active {
    background-color: #e3e3e3 !important; /* important to override hover color */
    color: black;
  }
  .autocomplete-result:hover {
    background-color: #e3e3e3;
    color: black; 
  }
  li {
    font-size: 22px;
  }
</style>
